import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch, Collapse, AutoComplete
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../services/ApiService"

import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"
import {API_BASE_URL} from "../configs/AppConfig";
import ModalPromesse from "./ModalPromesse";
import moment from 'moment'

import MultiAssocForm2 from "../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../components/permissions/PermissionAlert";
import ContactIcon from "../components/util-components/ContactIcon";
import ImageUploadField from "../components/custom-fields/ImageUpload";
import {getCountry, getDevise, getDeviseSymbol} from "../components/permissions/functions";
import COUNTRY from "country-json/src/country-by-abbreviation.json";
import ModalBasePaiement from "./ModalBasePaiement";
import {connect} from "react-redux";
import PromessesListForm from "../components/custom-fields/PromessesList";
import CampagneAddonForm from '../components/CampagneAddonForm';

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


class ModalCerfa extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        step: 0,
        defaultData: {},
        baseData:{},
        errorPromesses: false,
    };

    state = this.initstate

    async show(contact = null,assoc=null) {
        console.log("PAYEMENT CERFA ",)

        let defaultState={}
        if(assoc){
            defaultState={assoc:assoc, disableAssoc:true}
        }

        this.modalBasePaiement.show(contact,(baseData)=>{
            this.setState({visible: true, baseData: {...baseData}})
        },defaultState)
    }

    async showWithType(contact = null, type) {
        console.log("PAYEMENT Type ", type)
        this.modalBasePaiement.showWithType(contact,type,(baseData)=>{
            this.setState({visible: true, baseData: {...baseData}})
        })
    }


    close() {
        this.setState(this.initstate)
    }

    async onFinish(data) {
        console.log(data)

        if (this.state.loading) {
            return false
        }

        this.setState({loading:true})

        var config = {
            ...this.state.baseData,
            name:data.name,
            montant: data.montant,
            method: data.method,
            datetime: data.datetime.toDate(),
            cerfa: data.cerfa,
            commentaire: data.commentaire || null,
            extra: data.extra
        }


        if (config.type == "SERVICE") {
            config.service.nom = data.nom
            config.service.prenom = data.prenom
        }

        if (data.campagne) {
            config.campagne = data.campagne
        }

        if (Array.isArray(data.dettes) && data.dettes.length > 0) {
            config.dettes = data.dettes
        }

        var res = await ApiService.post("/paiements/cerfa/create/", config)
        console.log(res)

        if (res.success) {
            notification.success({
                message: t`Ajout effectué avec succès`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de l'ajout`
            })
        }
    }


    render() {

        const baseData= this.state.baseData;

        console.log("baseData",baseData)

        return (

            <Fragment>
                <Modal width={"100%"} style={{minHeight: 500}} title={t`Enregistrer un Paiement`}
                       open={this.state.visible} destroyOnClose closable footer={null} onCancel={() => this.close()}>
                    <PermissionAlert permissions={["paiement.add"]}>

                        <div style={{margin: "50px 50px"}}>
                            <Form
                                initialValues={{
                                    nom: baseData?.contact?.nom,
                                    prenom: baseData?.contact?.prenom,
                                    datetime: moment(new Date()),
                                    cerfa: baseData?.typeData?.type == "SERVICE" ? baseData?.typeData?.data?.cerfa : true,
                                    montant: baseData?.typeData?.type == "DETTE" ? baseData.typeData?.data?.reste : baseData.type == "SERVICE" ? baseData.typeData?.data?.montant : null,
                                }}
                                onFinish={(data) => this.onFinish(data)}
                            >

                                {baseData?.typeData?.type === "SERVICE" && (
                                    <Fragment>
                                        <Divider><Trans>Bénéficiaire du Service</Trans></Divider>
                                        <Row justify="space-around" align="center">

                                            <Form.Item
                                                label={t`Nom`}
                                                name="nom"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input placeholder={t`Nom`}/>
                                            </Form.Item>

                                            <Form.Item
                                                label={t`Prénom`}
                                                name="prenom"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <Input placeholder={t`Prénom`}/>
                                            </Form.Item>
                                        </Row>
                                        <Divider/>
                                    </Fragment>
                                )}


                                <Form.Item
                                    label={t`Nom du paiement`}
                                    name="name"
                                >
                                    <Input placeholder={t`Nom du paiement`}/>
                                </Form.Item>

                                <Form.Item
                                    label={t`Moyen de Paiement`}
                                    name="method"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <Select placeholder={t`Moyen de Paiement`}>
                                        <Option value="CHEQUE">{t`Chèque`}</Option>
                                        <Option value="VIREMENT">{t`Virement Bancaire`}</Option>
                                        <Option value="PRELEVEMENT">{t`Prélèvement Bancaire`}</Option>
                                        <Option value="CASH">{t`Espèces`}</Option>
                                        <Option value="CB">{t`Carte Bancaire`}</Option>
                                        <Option value="NATURE">{t`En Nature`}</Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item noStyle shouldUpdate>
                                    {()=>{
                                        const devise=this.props.org.cerfasInfos.find(i=>i.id===(baseData?.assoc || "MAIN"))?.devise || getDevise()
                                        return(
                                            <Form.Item
                                                label={t`Montant`}
                                                name="montant"
                                                rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                            >
                                                <InputNumber
                                                    decimalSeparator={','} min={1}
                                                    step={0.5}
                                                    addonAfter={getDeviseSymbol(devise)}
                                                />
                                            </Form.Item>
                                        )
                                    }}
                                </Form.Item>


                                {["GENERAL","CAISSE","LIVRET","CAMPAGNE"].includes(baseData?.typeData?.type) && baseData?.contact && (
                                    <Fragment>
                                        <PromessesListForm contactId={baseData.contact} assoc={baseData.assoc} errored={this.state.errorPromesses} onErrored={(bool)=>this.setState({errorPromesses:bool})}/>
                                    </Fragment>
                                )}

                                <Form.Item
                                    label={t`Date du paiement`}
                                    name="datetime"
                                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                                >
                                    <DatePicker showTime format="DD/MM/YYYY HH:mm"/>
                                </Form.Item>


                                <Form.Item
                                    label={t`Cerfa`}
                                    name="cerfa"
                                >
                                    <Switch
                                        defaultChecked={baseData?.typeData?.type == "SERVICE" ?baseData?.typeData?.data?.cerfa : true}/>
                                </Form.Item>


                                <Form.Item
                                    label={t`Commentaire`}
                                    name="commentaire"
                                >
                                    <Input.TextArea/>
                                </Form.Item>

                                <Form.Item noStyle
                                           shouldUpdate={(prevValues, curValues) => prevValues.method !== curValues.method}>
                                    {({getFieldValue}) => {
                                        const method = getFieldValue("method")
                                        console.log(method)

                                        if (method === "CHEQUE") {
                                            return (
                                                <Fragment>
                                                    <Divider><Trans>Informations du Chèque</Trans></Divider>
                                                    <Form.Item
                                                        label={t`Numéro du Chèque`}
                                                        name={["extra", "chequeId"]}
                                                    >
                                                        <Input placeholder={t`Numéro du Chèque`}/>
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={t`Image du Chèque`}
                                                        name={["extra", "chequeImage"]}
                                                    >
                                                        <ImageUploadField/>
                                                    </Form.Item>
                                                </Fragment>
                                            )
                                        }
                                    }}
                                </Form.Item>

                                {baseData?.typeData?.type === "CAMPAGNE" && (
                                    <CampagneAddonForm name={"campagne"} campagneId={baseData?.typeData?.value}/>
                                )}

                                <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button type="primary" htmlType="submit" disabled={this.state.loading || this.state.errorPromesses} loading={this.state.loading}>
                                        <Trans>Valider</Trans>
                                    </Button>
                                </Form.Item>

                            </Form>
                        </div>
                    </PermissionAlert>
                </Modal>

                <ModalBasePaiement title={t`Enregistrer un Paiement`} getRef={(ref)=>this.modalBasePaiement=ref}/>
            </Fragment>


        )
    }
}


const mapStateToProps = (state) => {
    return {
        org: state.auth.org
    }
}

export default connect(mapStateToProps)(ModalCerfa)
